import { executeRestAPICall } from "../services/generic.service";
import { CourseFeedResponse } from "./courses.types";


const ASSIGNED_COURSES_API = `${process.env.REACT_APP_LTI_BACKEND_API}/api/courses-assigned-to-customer/feed`;
const getCoursesAssignedToCustomerInContext = async (searchQuery?: string, skip=0, take=20) => {
  return await executeRestAPICall({
    method: "GET",
    url: `${ASSIGNED_COURSES_API}?q=${searchQuery ?? ""}&skip=${skip}&take=${take}`,
  }) as CourseFeedResponse;
};

export {getCoursesAssignedToCustomerInContext};
